var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"module-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"module-title-en"},[_vm._v(" "+_vm._s(_vm.title_en)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }